module.exports = __webpack_public_path__ + "static/media/S3N2.7fa60766.svg";